<template>
  <div>
    <slides-pc v-if="platform.isPC" />
    <slides-m v-else />
  </div>
</template>

<script>
import platform from "@utils/platform";
import SlidesM from "./SlidesM.vue";
import SlidesPc from "./SlidesPc.vue";

export default {
  components: { SlidesM, SlidesPc },
  data() {
    return { platform };
  },
};
</script>

<style scoped lang="scss">
</style>
